/* Chery Style (okt 2026) – mandje: "+ Toevoegen" bij "Maak je bestelling compleet" (snippets/cs-cart-complete.liquid).
   Eén luisteraar op document, dus het blijft werken nadat het mandje opnieuw is opgebouwd.
   Zelfde aanpak als chery-cart-upsells.js: /cart/add.js met de secties cart-drawer en cart-bubble, mandje blijft open. */
(function () {
  if (window.csCartComplete) return;
  window.csCartComplete = true;
  var busy = false;

  /* Het mandje-icoon opende de lade niet: CartDrawer werd pas aangemaakt na het eerste "In winkelwagen"
     (product.js), dus een tik op "Mandje" ging naar /cart. Nu wordt de lade bij het laden klaargezet
     (niet op de winkelwagenpagina zelf). */
  function initDrawer() {
    if (document.body && document.body.classList.contains('template-cart')) return;
    if (typeof CartDrawer !== 'undefined' && !CartDrawer.instance && document.getElementById('Cart-Drawer') && document.getElementById('cart-drawer-toggle')) {
      try { new CartDrawer(); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDrawer);
  else initDrawer();

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-cc-form]')) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    var box = form.closest('[data-cs-cc]');
    var button = form.querySelector('[type=submit]');
    var root = ((box && box.dataset.root) || '/').replace(/\/?$/, '/');
    var cartUrl = (box && box.dataset.cartUrl) || '/cart';
    var added = (box && box.dataset.added) || '';
    var variantId = Number(form.dataset.variantId || new FormData(form).get('id'));
    var wasAdded = false;
    if (button) button.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-bubble'], sections_url: window.location.pathname })
    })
      .then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok || result.status) throw new Error(result.description || 'error');
          return result;
        });
      })
      .then(function (result) {
        wasAdded = true;
        var parser = new DOMParser();
        var sections = result.sections || {};
        var incoming = parser.parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('#Cart-Drawer');
        var drawer = document.getElementById('Cart-Drawer');
        if (!incoming || !drawer) { window.location.assign(cartUrl); return; }
        var content = drawer.querySelector('.side-panel-content');
        var scrollTop = content ? content.scrollTop : 0;
        drawer.innerHTML = incoming.innerHTML;
        var bubble = parser.parseFromString(sections['cart-bubble'] || '', 'text/html').querySelector('.thb-item-count');
        var currentBubble = document.querySelector('#cart-drawer-toggle .thb-item-count');
        if (bubble && currentBubble) currentBubble.innerHTML = bubble.innerHTML;
        if (typeof CartDrawer !== 'undefined' && CartDrawer.instance) {
          CartDrawer.instance.removeProductEvent();
          CartDrawer.instance.notesToggle();
          CartDrawer.instance.termsCheckbox();
        }
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
        var newContent = drawer.querySelector('.side-panel-content');
        if (newContent) newContent.scrollTop = scrollTop;
        var status = drawer.querySelector('[data-cc-status]');
        if (status) status.textContent = added;
        var focusTarget = drawer.querySelector('.cs-cc__add') || drawer.querySelector('.checkout');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { items: result.items } }));
        if (document.getElementById('Cart')) document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (failure) {
        if (wasAdded) { window.location.assign(cartUrl); return; }
        var status = box && box.querySelector('[data-cc-status]');
        if (status) status.textContent = (failure && failure.message && failure.message !== 'error') ? failure.message : (document.documentElement.lang || 'nl').indexOf('nl') === 0 ? 'Toevoegen is niet gelukt. Probeer het nog eens.' : 'Could not add this item. Please try again.';
      })
      .finally(function () {
        busy = false;
        if (button && button.isConnected) button.disabled = false;
      });
  });
})();